

















































































import { Validator } from 'vee-validate'
import Vue from 'vue'
import { Component, Inject, Prop } from 'vue-property-decorator'
import InputFormKana from '../organisms/inquiry/InputFormKana.vue'
import InputFormName from '../organisms/inquiry/InputFormName.vue'

import SwitchByUa from '@/components/atoms/SwitchByUa.vue'
import { ApiContent } from '@/models/api/content'
import InputFormImage from '../organisms/inquiry/InputFormImage.vue'
import InputFormKindDropdown from '../organisms/inquiry/InputFormKindDropdown.vue'
import InputFormMailInquiry from '../organisms/inquiry/InputFormMailInquiry.vue'
import InputFormOrder from '../organisms/inquiry/InputFormOrder.vue'
import InputFormTel from '../organisms/inquiry/InputFormTel.vue'
import InputFormTextInquiry from '../organisms/inquiry/InputFormTextInquiry.vue'
import { InquiryForm, InquiryKind } from '../organisms/inquiry/model/InquiryKind'

@Component({
  components: {
    'spa-input-kind': InputFormKindDropdown,
    'spa-input-name': InputFormName,
    'spa-input-kana': InputFormKana,
    'spa-input-tel': InputFormTel,
    'spa-input-mail': InputFormMailInquiry,
    'spa-input-order': InputFormOrder,
    'spa-input-content': InputFormTextInquiry,
    'spa-input-image': InputFormImage,
    SwitchByUa,
  },
})
export default class InquiryTop extends Vue {
  @Inject()
  $validator: Validator

  @Prop({ default: [] })
  freeAreas: ApiContent[]

  @Prop({ required: true })
  kindLabels: InquiryKind[]

  @Prop({ required: true })
  canModifyKind: boolean

  @Prop({ required: true })
  isOrderRequired: boolean

  @Prop({ required: true })
  form: InquiryForm

  @Prop({ required: true })
  input: (field: string, value: string|number) => void

  @Prop({ required: true })
  uploadImage: (value: File|null, index: number) => void

  @Prop({ required: true })
  deleteImage: (index: number) => void
}
